export default "__VITE_ASSET__bcacc2f6__"